/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="92.84"
        height="92.48"
        viewBox="0 0 92.84 92.48"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#0e497b"
          d="M75.56 92.48h-2.5v-5.26c0-9.66-17.84-13.11-24.16-14a17.93 17.93 0 01-11.12 3.57 18.54 18.54 0 01-11.06-3.5C15.42 75 2.5 79.63 2.5 87.29v5.26H0v-5.26c0-9.31 13.89-14.63 26.88-16.5a1.25 1.25 0 011 .26 16.05 16.05 0 009.93 3.29 15.44 15.44 0 0010-3.35 1.23 1.23 0 01.95-.27C73 74.03 75.61 83.41 75.61 87.29z"
          className="icon-fill icon-base"/><path
          fill="#0e497b"
          d="M68.24 50.89a1.24 1.24 0 01-.53-.12 1.26 1.26 0 01-.71-1.13v-7.71h-7.4a1.25 1.25 0 010-2.5h8.65a1.25 1.25 0 011.25 1.25V47l8.76-7.26a1.25 1.25 0 01.8-.29h5.88a5.4 5.4 0 005.41-5.25V7.75a5.34 5.34 0 00-5.41-5.25H42.57a5.34 5.34 0 00-5.41 5.25v15.79a1.25 1.25 0 01-2.5 0V7.75A7.84 7.84 0 0142.57 0h42.36a7.84 7.84 0 017.91 7.75v26.43a7.84 7.84 0 01-7.91 7.75H79.5L69 50.6a1.27 1.27 0 01-.8.29"
          className="icon-fill icon-base"/><path
          fill="#0e497b"
          d="M27.44 48c.56 8 5.64 15.75 10.63 15.75 5.33 0 10-7.57 10-16.21a16 16 0 00-1.62-7.59c-2.14 2.17-7.57 6.27-19 8m10.62 18.28C31.13 66.23 25.64 57 25 48.31c-1.49.18-3.07.31-4.74.4l-.13-2.49c20.16-1.09 25.38-8.93 25.43-9l.93-1.46 1.09 1.34c3.38 4.14 3 10.25 3 10.51 0 9-5 18.63-12.51 18.63"
          className="icon-fill icon-base"/><path
          fill="#0e497b"
          d="M25.65 68.39c-6.7-11.52-8.11-24.6-3.53-32.56 3.05-5.3 8.53-8.1 15.83-8.1 6.74 0 11.94 2.75 15 7.94 4.79 8 3.78 20.84-2.58 32.68l-2.2-1.18c6-11.08 7-22.94 2.63-30.22-2.62-4.39-7.08-6.72-12.89-6.72-6.45 0-11.05 2.3-13.66 6.84-4.09 7.1-2.64 19.46 3.52 30.06z"
          className="icon-fill icon-base"/><path
          fill="#ffb81c"
          d="M63.91 9.77A6.24 6.24 0 0057.67 16a8.38 8.38 0 001.67 4.58A10 10 0 0161 24.16h6a10.9 10.9 0 011.62-3.59A8.31 8.31 0 0070.15 16a6.24 6.24 0 00-6.24-6.21zM60 26.16a1 1 0 01-.71-.29 1 1 0 01-.29-.71 7 7 0 00-1.4-3.56 10.22 10.22 0 01-2-5.62 8.24 8.24 0 0116.48 0 10.21 10.21 0 01-1.91 5.62 7.67 7.67 0 00-1.45 3.61 1 1 0 01-1 .94z"
          className="icon-fill icon-accent"/><path
          fill="#ffb81c"
          d="M67.93 27.55c-.2 2.22-.57 5.42-3.88 5.42-3.7 0-4-3.32-4.16-5.42"
          className="icon-fill icon-accent"/><path
          fill="#ffb81c"
          d="M59.89 17.39h-.1a1 1 0 01-.9-1.09 5.73 5.73 0 011.66-3.51 4.64 4.64 0 013.53-1.27 1 1 0 01.85 1.13 1 1 0 01-1.11.85 2.85 2.85 0 00-2 .81 3.86 3.86 0 00-1 2.18 1 1 0 01-1 .91"
          className="icon-fill icon-accent"/>
      </svg>

    );
  }
}

Icon.displayName = 'PersonWithLightbulbWordBubbleIcon';

export default Icon;
